import Drag from './Drag';
import Drop from './Drop';
import Provider from './Provider';
import DropListOptionWrapper from './DropListOptionWrapper';

import { CompoundedComponent } from './interfaces';

const DND = {
  Drag,
  Drop,
  Provider,
  DropListOptionWrapper,
} as CompoundedComponent;

export * from './interfaces';
export * from './ItemTypes';
export default DND;
